import { useNavigate, useLocation } from 'react-router-dom';
import { Home, Store, Plus, Calendar, User, HandCoins, LayoutGrid, Shield } from 'lucide-react';

// Local logo
const LOGO_URL = '/logo.png';

export function AgentLayout({ children, onAddClick, overdueCount = 0, missedPtpCount = 0 }) {
  const navigate = useNavigate();
  const loc = useLocation();
  const user = JSON.parse(localStorage.getItem('au_user') || '{}');
  const initials = user.name ? user.name.split(' ').map(p => p[0]).join('').toUpperCase().slice(0, 2) : 'AU';
  const isManager = user.role === 'manager';
  const isAdmin = user.role === 'admin';
  // Managers and admins always have recovery; otherwise honor the per-agent flag.
  const recoveryEnabled = isManager || isAdmin || user.recoveryEnabled === true;

  const navItems = recoveryEnabled
    ? [
        { path: '/dashboard', icon: Home, label: 'Home' },
        { path: '/merchants', icon: Store, label: 'Merchants' },
        { path: null, icon: Plus, label: 'Add', isAdd: true },
        { path: '/followups', icon: Calendar, label: 'Follow-ups', badge: overdueCount > 0 },
        { path: '/recovery', icon: HandCoins, label: 'Recovery', badge: missedPtpCount > 0, matchPrefix: '/recovery' },
      ]
    : [
        { path: '/dashboard', icon: Home, label: 'Home' },
        { path: '/merchants', icon: Store, label: 'Merchants' },
        { path: null, icon: Plus, label: 'Add', isAdd: true },
        { path: '/followups', icon: Calendar, label: 'Follow-ups', badge: overdueCount > 0 },
        { path: '/profile', icon: User, label: 'Profile' },
      ];

  const handleAddClick = () => {
    if (onAddClick) {
      onAddClick();
    } else {
      navigate('/dashboard?addMerchant=true');
    }
  };

  return (
    <div className="au-agent-wrap">
      {/* Top Bar */}
      <div className="au-topbar">
        <div className="tb-logo">
          <img src={LOGO_URL} alt="Amravati Urban" className="tb-logo-img" />
          <div>
            <div className="tb-brand">
              <span className="au-amravati">Amravati</span>
              <span className="au-urban"> Urban</span>
            </div>
            <div className="tb-sub">Co-Op Credit Society</div>
          </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          {isManager && (
            <button
              onClick={() => navigate('/owner/recovery')}
              title="Branch portal"
              style={{
                display: 'inline-flex', alignItems: 'center', gap: '4px',
                padding: '6px 10px', borderRadius: '8px', border: '1px solid var(--g2, #d1d5db)',
                background: '#fff', fontSize: '12px', fontWeight: 600, color: 'var(--navy, #0b2545)',
                cursor: 'pointer'
              }}
              data-testid="branch-portal-btn"
            >
              <LayoutGrid size={14} /> Branch
            </button>
          )}
          {isAdmin && (
            <button
              onClick={() => navigate('/admin')}
              title="Admin panel"
              style={{
                display: 'inline-flex', alignItems: 'center', gap: '4px',
                padding: '6px 10px', borderRadius: '8px', border: '1px solid var(--g2, #d1d5db)',
                background: '#fff', fontSize: '12px', fontWeight: 600, color: 'var(--navy, #0b2545)',
                cursor: 'pointer'
              }}
              data-testid="admin-panel-btn"
            >
              <Shield size={14} /> Admin Panel
            </button>
          )}
          <div className="tb-right" onClick={() => navigate('/profile')} style={{ cursor: 'pointer' }} title="Profile">
            <div>
              <div className="tb-name">{user.name?.split(' ')[0] || (isManager ? 'Manager' : isAdmin ? 'Admin' : 'Agent')}</div>
              <div className="tb-id">{user.employeeId}</div>
            </div>
            <div className="tb-av">{initials}</div>
          </div>
        </div>
      </div>

      {/* Page Content */}
      {children}

      {/* Bottom Navigation - flat layout */}
      <nav className="bnav">
        {navItems.map((item) => {
          const isActive = item.path && (
            item.matchPrefix ? loc.pathname.startsWith(item.matchPrefix) : loc.pathname === item.path
          );
          if (item.isAdd) {
            return (
              <div 
                key="add" 
                className="ntab add-ntab" 
                onClick={handleAddClick} 
                data-testid="add-merchant-nav-btn"
              >
                <div className="ni add-icon">
                  <Plus size={20} strokeWidth={2.5} />
                </div>
                <span className="nl add-label">Add</span>
              </div>
            );
          }
          return (
            <div
              key={item.path}
              className={`ntab ${isActive ? 'active' : ''}`}
              onClick={() => navigate(item.path)}
              data-testid={`nav-${item.label.toLowerCase().replace('-', '')}`}
            >
              <div className={item.badge ? 'ni bdot' : 'ni'}>
                <item.icon size={19} />
              </div>
              <span className="nl">{item.label}</span>
            </div>
          );
        })}
      </nav>
    </div>
  );
}
